import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './badge.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Badge = _ref => {
  var colour = _ref.colour,
    textColour = _ref.textColour,
    children = _ref.children;
  return ___EmotionJSX("div", {
    css: styles.badge(colour, textColour)
  }, children);
};
Badge.propTypes = {
  colour: PropTypes.string,
  textColour: PropTypes.string,
  children: PropTypes.string
};
Badge.defaultProps = {
  colour: undefined,
  textColour: undefined,
  children: ''
};
export default Badge;